import React from 'react';

import ToggleSlider from '#/components/basic/inputs/ToggleSlider/ToggleSlider';
import ConfirmationModal from '#/components/basic/modal/ConfirmationModal';
import { changeSkipBuySellConfirmation } from '#/reduxState/exchange/userGuideReducer';
import { staticDispatch, useSelector } from '#/reduxState/store';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
  isBuy: boolean;
};

export default function ConfirmOrderModal({
  onClose,
  onConfirm,
  isBuy,
}: Props) {
  const skipBuySellConfirmation = useSelector(
    state => state.exchange.userGuide.skipBuySellConfirmation
  );

  return (
    <ConfirmationModal
      onConfirm={onConfirm}
      onClose={onClose}
      confirmText={isBuy ? 'Confirm buy' : 'Confirm sell'}
      processing={false}
      confirmButtonProps={{ autoFocus: true }}
      title="Confirm Order"
      childrenBottom={
        <ToggleSlider
          checked={skipBuySellConfirmation}
          onChange={value =>
            staticDispatch(changeSkipBuySellConfirmation(value))
          }
        >
          Do not ask me again
        </ToggleSlider>
      }
    >
      <span style={{ color: 'var(--gray4c)' }}>Your order will be placed.</span>
    </ConfirmationModal>
  );
}
